import router from '@/router'

router.beforeEach((to,from,next)=>{
    let userInfo=JSON.parse(localStorage.getItem('logininfo'))?JSON.parse(localStorage.getItem('logininfo')).user:""
    if(userInfo==""&&to.path !== "/login"){
        next({ path: '/login' })
        return
    }
    next()
})
export default router